import { render, staticRenderFns } from "./ProofreadingRuleDescriptionDialog.vue?vue&type=template&id=0e30fdb1&scoped=true"
import script from "./ProofreadingRuleDescriptionDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingRuleDescriptionDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingRuleDescriptionDialog.vue?vue&type=style&index=0&id=0e30fdb1&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e30fdb1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e30fdb1')) {
      api.createRecord('0e30fdb1', component.options)
    } else {
      api.reload('0e30fdb1', component.options)
    }
    module.hot.accept("./ProofreadingRuleDescriptionDialog.vue?vue&type=template&id=0e30fdb1&scoped=true", function () {
      api.rerender('0e30fdb1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingRuleDescriptionDialog.vue"
export default component.exports